// extracted by mini-css-extract-plugin
module.exports = {"header":"HeaderCareerDepartment_header__wh8Zj","text":"HeaderCareerDepartment_text__CMh7a"};